module.exports = __webpack_public_path__ + "img/milan.56087666.png";